<template>
    <div>
        <v-form
        ref="form"
        v-model="valid"
        v-on:submit.prevent
        >
            <v-snackbar
            :color="color"
            :timeout="60000"
            v-model="alert"
            top
            id="snackbar"
            >
              <v-row>
                {{text}}
                <v-spacer></v-spacer>
                <v-icon color="white" @click="alert = false">mdi-close</v-icon>
              </v-row>
            </v-snackbar>
            <v-row no-gutters class="mt-2">
                <city type="carPickup" />
                <city type="carDrop"/>

                <v-col cols="12" sm="6" md="6" lg="2">
                  <datePicker type="Pickup Date" />
                </v-col>
                <v-col cols="12" sm="6" md="6" lg="2">
                  <timePicker type="Pickup Time" />
                </v-col>
                <v-col cols="12" sm="6" md="6" lg="2">
                  <datePicker type="Drop Date" />
                </v-col>
                <v-col cols="12" sm="6" md="6" lg="2">
                  <timePicker type="Drop Time" />
                </v-col>
                <!-- <v-col cols="12" :md="dropOff ? 12 : 4" lg="2">
                    <v-btn
                    type="submit"
                    @click="submit"
                    tile
                    block
                    :color="$store.state.mode === 'ats' || $store.state.mode === 'adam' || $store.state.mode === 'atsDev' || $store.state.mode === 'adamDev' ? 'orange' : 'secondary'"
                    height="52"
                    dark
                    class="mr-1"
                    id="cars-search-submit"
                    >
                    Search
                    </v-btn>
                </v-col> -->
                <!-- <city type="carDrop" class="d-none d-lg-flex"/> -->
            </v-row>
            <v-row no-gutters justify="center">
              <v-btn
              type="submit"
              @click="submit"
              tile
              :color="$store.state.mode === 'ats' || $store.state.mode === 'adam' || $store.state.mode === 'atsDev' || $store.state.mode === 'adamDev' ? 'orange' : 'blueDark'"
              height="52"
              dark
              class="px-10 rounded-lg"
              id="cars-search-submit"
              >
              Search
              </v-btn>
            </v-row>
        </v-form>
    </div>
</template>

<script>
import city from './citiesAutocomplete.vue'
import datePicker from './datePicker.vue'
import timePicker from './timePicker.vue'

export default {
  components: {
    datePicker,
    timePicker,
    city
  },
  data () {
    return {
      valid: true,
      color: '',
      alert: false,
      text: '',
      dropOff: false
    }
  },
  methods: {
    submit () {
      this.$refs.form.validate()
      if (this.valid) {
        const store = this.$store.state.carInfo
        if (new Date(store.pickup).getTime() > new Date().getTime()) {
          if (new Date(store.pickup).getTime() <= new Date(store.drop).getTime()) {
            let term = `pickUpDate=${store.pickup}&pickUpTime=${store.pickupTime}&returnDate=${store.drop}&returnTime=${store.dropTime}&pickUpLocation=${store.pickupLocation.Code}&sortOrder=ASC`
            if (store.dropLocation) term += `&dropOffLocation=${store.dropLocation.Code}`
            this.$store.dispatch('setCarsTimeOut', false)
            this.$store.dispatch('removeCarsResults')
            if (this.$store.state.carsSearchTimeOutFunction !== null) this.$store.dispatch('clearCarsSearchTimeOutFunction')
            if (this.$store.state.carsTimeOutFunction) this.$store.dispatch('clearCarsTimeOutFunction')
            if (this.$route.name === 'carsResults') {
              this.$emit('addCars', term)
            } else this.$router.push({ name: 'carsResults', params: { term: term } })
          } else {
            this.alert = true
            this.color = 'error'
            this.text = 'Please drop date after the pickp date'
          }
        } else {
          this.alert = true
          this.color = 'error'
          this.text = 'Please choose pickup date after today date'
        }
      } else {
        this.alert = true
        this.color = 'warning'
        this.text = 'Please fill all fields'
      }
    }
  }
}
</script>
